// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation-module--navigation--Szcvz","navbarNav":"navigation-module--navbarNav--3jYMN","gatsbyImageWrapper":"navigation-module--gatsbyImageWrapper--1ExzE"};